import FilterComponent from "../../../components/FilterComponent";
import { Table, Space, Card, Modal, Tooltip } from 'antd';
import {
    ReadOutlined,
    DeleteOutlined,
    InfoCircleOutlined
} from '@ant-design/icons'

import { columnsDefs } from "../columnDefs";
import { useEffect, useState } from "react";
import { deleteClientesById, getAllClientes } from "../../../api/clientes";
import { ClienteType } from "../../../types/ClienteTypes";
import { useLoading } from "../../../contexts/LoadingContext";
import { useNavigate } from "react-router-dom";
import { ColumnsType } from "antd/es/table";
import { getColumnSearchProps } from "../../../components/GetColumnSearch";


export default function Imobiliario() {
    const [data, setData] = useState<ClienteType[]>([]);
    const [selectedCliente, setSelectedCliente] = useState<any>(null);
    const [btnLoadinButton, setBtnLoadingButton] = useState<boolean>(false);
    const [openModal, setOpenModal] = useState(false);
    const { setLoading } = useLoading();
    let navigate = useNavigate();

    const columnDefsWithActions: ColumnsType<any> = [{
        title: "Nome",
        dataIndex: "nome",
        key: "nome",
        ...getColumnSearchProps('nome', 'Nome'),
    }, ...columnsDefs, {
        title: "Ações",
        key: "executar",
        render: (_: any, record: any) => (
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
                <Space size="middle">
                    <ReadOutlined style={{ fontSize: '20px' }} onClick={() => navigate(`/demandas/geral/cliente/${record.id}`)} />
                    <DeleteOutlined style={{ fontSize: '20px' }} onClick={() => {
                        setSelectedCliente(record);
                        showModal();
                    }
                    } />
                </Space>
            </div>
        ),
    },
    ];

    const getAllClientesfromApi = async () => {
        try {
            setLoading(true);
            const response = await getAllClientes();
            const filteredData = response.data.filter((item: ClienteType) => item.acoes.some((acao) => acao.id === 'eaf76b4a-dd96-43c6-a7ff-83b962bf41e5'));
            setData(filteredData);
            setLoading(false);
            return response;
        } catch (error) {
            console.error('Erro ao obter dados da API:', error);
        }
    };
    const showModal = () => {
        setOpenModal(true);
    };

    const handleCancel = () => {
        setOpenModal(false);
    };

    const handleOk = async () => {
        setBtnLoadingButton(true);
        const response = await deleteClientesById(selectedCliente.id);
        if (response) {
            getAllClientesfromApi();
            setOpenModal(false);
            setBtnLoadingButton(false);
        }
    };

    useEffect(() => {
        getAllClientesfromApi();
    }, []);

    return (
        <>
            <Space direction="vertical" style={{ display: 'flex' }}>
                <Card title={<>Lista de clientes <Tooltip placement="bottom" title="Para criar um novo cadastro de cliente, clique no botão 'Novo' no canto superior direito da tela.">
                    <InfoCircleOutlined />
                </Tooltip></>}>
                    <Table columns={columnDefsWithActions || []} dataSource={data || []} rowKey={(record) => record.id} pagination={{ pageSize: 12 }} />
                </Card>
            </Space>
            <Modal
                open={openModal}
                title="Atenção!"
                onOk={handleOk}
                onCancel={handleCancel}
                confirmLoading={btnLoadinButton}
                footer={(_, { OkBtn, CancelBtn }) => (
                    <>
                        <CancelBtn />
                        <OkBtn />
                    </>
                )}
            >
                <p>Você tem certeza que deseja apagar o cliente?</p>
                <p>Isso irá apagar todos os dados inclusive os anexos</p>
            </Modal>
        </>
    )
}
